@if (quoteRequestForm !== undefined) {
<div [formGroup]="quoteRequestForm.controls.requestDetails">
  <!-- If we are Sole Prop/Individual - we render the form differently -->
  @if(this.quoteRequestForm.controls.bondLookup.controls.company_type_id.value === 3) {
  <cipx-quote-request-intake-form-request-details-owners
    [quoteRequestForm]="
      quoteRequestForm
    "></cipx-quote-request-intake-form-request-details-owners>
    <cipx-quote-request-intake-form-request-details-bond-information
    [quoteRequestForm]="
      quoteRequestForm
    "></cipx-quote-request-intake-form-request-details-bond-information>
  } @else {
  <cipx-quote-request-intake-form-request-details-bond-information
    [quoteRequestForm]="
      quoteRequestForm
    "></cipx-quote-request-intake-form-request-details-bond-information>
  <cipx-quote-request-intake-form-request-details-owners
    [quoteRequestForm]="
      quoteRequestForm
    "></cipx-quote-request-intake-form-request-details-owners>
  }

  <!-- <cipx-quote-request-intake-form-request-details-bond-information
    (companyTypeIdChanged)="onCompanyTypeIdChanged($event)"
    (companyNumberOwnersChanged)="onCompanyNumberOwnersChanged($event)"
    [quoteRequestForm]="
      quoteRequestForm
    "></cipx-quote-request-intake-form-request-details-bond-information> -->


  <!-- <cipx-quote-request-intake-form-request-details-additional-comments
    [quoteRequestForm]="
      quoteRequestForm
    "></cipx-quote-request-intake-form-request-details-additional-comments> -->
<!--
    <div class="cipx-form-form-group text-right">
      <button mat-flat-button color="primary" (click)="stageComplete()">
        Next
        <mat-icon svgIcon="heroicons_outline:chevron-right"></mat-icon>
      </button>
    </div> -->

</div>
}
